import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AdminBadgeModule } from '@ui-components/admin/badge';
import { AdminConfirmDialogModule } from '@ui-components/admin/confirm-dialog';
import { AdminOrgPickerModule } from '@ui-components/admin/org-picker';
import { AdminStateModule } from '@ui-components/admin/state';

import { MovePanelComponent } from './move-panel/move-panel.component';

// MovePanelComponent is projected from AppComponent into the shell's
// companion region (TK-077), so it cannot be declared inside a lazily loaded
// feature module — it needs its own eagerly loaded module instead.
@NgModule({
  declarations: [MovePanelComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    AdminOrgPickerModule,
    AdminBadgeModule,
    AdminStateModule,
    AdminConfirmDialogModule,
  ],
  exports: [MovePanelComponent],
})
export class PeopleMoveModule {}
